var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'menu-open' : _vm.isSidebarOpen }},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"dashboard d-flex"},[_c('LeftSide'),_vm._v(" "),_c('div',{staticClass:"dashboard-right"},[_c('child')],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3e29e3e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/layouts/admin.vue
// module id = sqWp
// module chunks = 54